import { render, staticRenderFns } from "./ConfirmAnnouncement.vue?vue&type=template&id=e9c361f2&"
import script from "./ConfirmAnnouncement.vue?vue&type=script&lang=js&"
export * from "./ConfirmAnnouncement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports